import { TextInput, Textarea, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import { Role } from "../../../services/admin/roles.service";
import { required, scrollToFirstError } from "../../../utils/formValidation";

export interface RoleFormValues {
  name: string;
  description: string;
}

interface RoleFormProps {
  initialValues?: Role;
  onSubmit: (values: RoleFormValues) => void;
  isLoading?: boolean;
}

export default function RoleForm({
  initialValues,
  onSubmit,
  isLoading,
}: RoleFormProps) {
  const form = useForm<RoleFormValues>({
    initialValues: {
      name: initialValues?.name || "",
      description: initialValues?.description || "",
    },
    validate: {
      name: required("Role name is required"),
    },
  });

  // Reset form when initialValues change (e.g., when editing different role)
  useEffect(() => {
    form.setValues({
      name: initialValues?.name || "",
      description: initialValues?.description || "",
    });
    form.clearErrors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues?.id]);

  const handleSubmit = form.onSubmit(
    (values) => onSubmit(values),
    () => scrollToFirstError(form)
  );

  return (
    <form noValidate onSubmit={handleSubmit}>
      <Stack gap="md">
        <TextInput
          label="Role Name"
          placeholder="e.g., Operations Manager, Histotech"
          withAsterisk
          disabled={isLoading}
          {...form.getInputProps("name")}
        />

        <Textarea
          label="Description"
          placeholder="Enter role description and responsibilities"
          minRows={3}
          disabled={isLoading}
          {...form.getInputProps("description")}
        />
      </Stack>
    </form>
  );
}

export { useForm } from "@mantine/form";
